import { useGetPublicUser } from '@/app/hooks/useGetPublicUser'
import { useParams } from 'react-router-dom'

const useCreditSellerCardController = () => {
  const { linkName } = useParams()

  const { data: seller } = useGetPublicUser(linkName || '')

  const handleWhatsAppClick = () => {
    const phoneNumber = seller?.phone?.replace(/\D/g, '')
    const message = `Olá ${seller?.name}, preciso de ajuda!`
    const whatsappUrl = `${import.meta.env.VITE_SELLER_SUPPORT}/55${phoneNumber}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  return {
    seller,
    handleWhatsAppClick,
  }
}

export default useCreditSellerCardController
